import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Waves } from "@material-ui/icons";
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Button,
} from "@material-ui/core";
import { Actions as Imagery } from "../../../store/ducks/imagery";
import ReactGA from "react-ga";
import { Line  } from "react-chartjs-2";

const ActionList = ({ name }) => {
  const hasShorelineData = useSelector((state) =>
    Boolean(state.results.coastlineData)
  );

  const dispatch = useDispatch();
  const [t] = useTranslation();
  const [showPopup, setShowPopup] = useState(false);
  const [chartData, setChartData] = useState(null);

  const handleOpenPopup = () => {
    const transectMatrix = window.initMap?.transectMatrix || [];
    console.log("TransectMatrix do mapa:", transectMatrix);

    const labels = transectMatrix.map((t) => t.id);
    const averages = transectMatrix.map((t) => {
      const sum = t.distances.reduce((a, b) => a + b, 0);
      return parseFloat((sum / t.distances.length).toFixed(2));
    });

    setChartData({
      labels,
      datasets: [
        {
          label: "Média das distâncias",
          data: averages,
          backgroundColor: "#00B3A1",
        },
      ],
    });

    setShowPopup(true);
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Média por transecto",
    },
  };

  return (
    <>
      <List>
        <ListItem
          button
          onClick={() => {
            ReactGA.event({
              category: "Actions",
              action: "analyzeCoastline",
            });
            dispatch(Imagery.analyzeCoastline());
          }}
        >
          <ListItemAvatar>
            <Avatar>
              <Waves />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={t("forms.imageChooser.actions.analyzeShoreline.title")}
            style={{ paddingRight: 48 }}
          />
        </ListItem>

        {hasShorelineData && (
          <div style={{ padding: "16px", textAlign: "center" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenPopup}
            >
              Ver perfil médio dos transectos
            </Button>
          </div>
        )}
      </List>

      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "24px",
              borderRadius: "8px",
              width: "90%",
              maxWidth: "700px",
              boxShadow: "0 0 20px rgba(0,0,0,0.3)",
              textAlign: "center",
            }}
          >
            <h3>Perfil médio dos transectos</h3>

            <div style={{ height: "300px", marginBottom: "24px" }}>
              {chartData ? (
                <Line data={chartData} options={chartOptions} />
              ) : (
                <p>Nenhum transecto disponível.</p>
              )}
            </div>

            <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setShowPopup(false)}
              >
                Fechar
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ActionList;